import React from "react";
import "./PrevArrow.css";
import forwardArrow from "./../../../Images/forward-arrow.png";
function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <>
      <div onClick={onClick}>
        <span className="arrow-prev">
          <img src={forwardArrow} />
        </span>
      </div>
    </>
  );
}
export default PrevArrow;
